import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoCartOutline } from "react-icons/io5";
import { CiUser } from "react-icons/ci";
import { Button, Drawer, Modal } from 'antd';
import axios from 'axios';
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from 'react-toastify';
import { useCart } from './CartContext';

const Cart = () => {
  const navigate = useNavigate();
  const { isCartOpen, closeCart, openCart, cartData, setCartData, fetchCartData } = useCart();

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [customizeData2, setCustomizeData2] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  const handleCheckout = () => {
    if (!cartData?.AddToCartDetails?.[0]?.length) {
      toast.warn("Cart is empty!");
      return;
    }
    //add
      const user = JSON.parse(localStorage.getItem('user'));
    if (!user?.UserID) {
        toast.info("Please login to checkout");
        navigate('/login', { state: { redirectTo: '/checkout' } });
        return;
    }
    navigate('/checkout');
  };

useEffect(() => {
  if (user?.UserID) {
    fetchCartData();
  }

  const interval = setInterval(() => {
    if (user?.UserID) {
      fetchCartData();
    }
  }, 10000); // 10 seconds

  return () => clearInterval(interval);
}, []);
  useEffect(() => {
    if (isCartOpen) {
      fetchCartData();

      axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/viewcustomize`)
        .then((res) => {
          setCustomizeData2(res.data.View_Customize || []);
        })
        .catch((err) => {
          // console.error("Error fetching customize data:", err);
        });
    }
  }, [isCartOpen, fetchCartData]);

  // const deleteCartItem = async (item) => {
  //   try {
  //     const payload = {
  //       Product_ID: item.Product_Id,
  //       Customer_ID: user.UserID,
  //       Category_ID: item.Category_ID,
  //       SubCategory_ID: item.SubCategory_ID
  //     };

  //     const res = await axios.post(
  //       `${process.env.REACT_APP_SECRET_KEY}/api/deletecartitem`,
  //       payload
  //     );

  //     if (res.status === 200) {
  //       toast.success(`${item.Product_Name} removed from cart`);

  //       setCartData(prev => {
  //         if (!prev?.AddToCartDetails) return prev;

  //         const updatedItems = prev.AddToCartDetails[0].filter(cartItem => cartItem.Product_Id !== item.Product_Id);
  //         const updatedFinalAmount = updatedItems.reduce((sum, i) => sum + i.Rate * i.Quantity, 0);

  //         return {
  //           ...prev,
  //           AddToCartDetails: [
  //             updatedItems,
  //             [{ FinalAmount: updatedFinalAmount }]
  //           ]
  //         };
  //       });

  //       fetchCartData();
  //     }
  //   } catch (error) {
  //   //  console.error ("Delete failed:", error);
  //     toast.error("Failed to remove item");
  //   }
  // };
const deleteCartItem = async (item) => {
    const user = JSON.parse(localStorage.getItem('user'));

    // ✅ Guest
    if (!user?.UserID) {
        const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
        const updated = guestCart.filter(i => i.Product_Id !== item.Product_Id);
        localStorage.setItem('guestCart', JSON.stringify(updated));
        toast.success(`${item.Product_Name} removed from cart`);
        fetchCartData();
        return;
    }

    // ✅ Logged in
    try {
        const payload = {
            Product_ID: item.Product_Id,
            Customer_ID: user.UserID,
            Category_ID: item.Category_ID,
            SubCategory_ID: item.SubCategory_ID
        };
        const res = await axios.post(
            `${process.env.REACT_APP_SECRET_KEY}/api/deletecartitem`,
            payload
        );
        if (res.status === 200) {
            toast.success(`${item.Product_Name} removed from cart`);
            fetchCartData();
        }
    } catch (error) {
        toast.error("Failed to remove item");
    }
};
  // const updateQuantity = async (item, newQuantity) => {
  //   try {
  //     if (newQuantity <= 0) {
  //       await deleteCartItem(item);
  //     } else {
  //       const payload = {
  //         Product_ID: item.Product_Id,
  //         Customer_ID: user.UserID,
  //         Category_ID: item.Category_ID || item.Category_Id,
  //         SubCategory_ID: item.SubCategory_ID || item.SubCategory_Id,
  //         Quantity: newQuantity
  //       };

  //       await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, payload);

  //       setCartData(prev => {
  //         if (!prev?.AddToCartDetails) return prev;

  //         const updatedItems = prev.AddToCartDetails[0].map(cartItem =>
  //           cartItem.Product_Id === item.Product_Id
  //             ? { ...cartItem, Quantity: newQuantity, TotalAmount: newQuantity * cartItem.Rate }
  //             : cartItem
  //         );

  //         const updatedFinalAmount = updatedItems.reduce((sum, i) => sum + i.Rate * i.Quantity, 0);

  //         return {
  //           ...prev,
  //           AddToCartDetails: [
  //             updatedItems,
  //             [{ FinalAmount: updatedFinalAmount }]
  //           ]
  //         };
  //       });
  //     }
  //   } catch (error) {
  //     // console.error("Failed to update quantity:", error);
  //   }
  // };
const updateQuantity = async (item, newQuantity) => {
    const user = JSON.parse(localStorage.getItem('user'));

    // ✅ Guest — localStorage update
    if (!user?.UserID) {
        if (newQuantity <= 0) {
            const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
            const updated = guestCart.filter(i => i.Product_Id !== item.Product_Id);
            localStorage.setItem('guestCart', JSON.stringify(updated));
        } else {
            const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
            const updated = guestCart.map(i =>
                i.Product_Id === item.Product_Id
                    ? { ...i, Quantity: newQuantity }
                    : i
            );
            localStorage.setItem('guestCart', JSON.stringify(updated));
        }
        fetchCartData();
        return;
    }

    // ✅ Logged in — API call
    try {
        if (newQuantity <= 0) {
            await deleteCartItem(item);
        } else {
            const payload = {
                Product_ID: item.Product_Id,
                Customer_ID: user.UserID,
                Category_ID: item.Category_ID || item.Category_Id,
                SubCategory_ID: item.SubCategory_ID || item.SubCategory_Id,
                Quantity: newQuantity
            };
            await axios.post(
                `${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`,
                payload
            );
            setCartData(prev => {
                if (!prev?.AddToCartDetails) return prev;
                const updatedItems = prev.AddToCartDetails[0].map(cartItem =>
                    cartItem.Product_Id === item.Product_Id
                        ? { ...cartItem, Quantity: newQuantity }
                        : cartItem
                );
                const updatedFinalAmount = updatedItems.reduce(
                    (sum, i) => sum + i.Rate * i.Quantity, 0
                );
                return {
                    ...prev,
                    AddToCartDetails: [updatedItems, [{ FinalAmount: updatedFinalAmount }]]
                };
            });
        }
    } catch (error) {}
};
  const handleQuickView = (item) => {
    setSelectedProduct(item);
    setQuantity(parseInt(item.Quantity));
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const handleCartWhatsAppMessage = () => {
    if (!cartData?.AddToCartDetails?.[0]?.length) {
      toast.warn("Cart is empty!");
      return;
    }


    const productsList = cartData.AddToCartDetails[0].map(item => {
      const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);

      let itemMessage = `────────────────────\n`;
      itemMessage += `Product: ${item.Product_Name}\n`;
      itemMessage += `Category: ${item.Category || 'N/A'}\n`;
      itemMessage += `Subcategory: ${item.SubCategory || 'N/A'}\n`;
      itemMessage += `Size: ${item.Size || 'Standard'}\n`;
      itemMessage += `Quantity: ${item.Quantity}`;

      if (customize) {
        if (customize.custom_description && customize.custom_description.trim() !== "") {
          itemMessage += `\nCustom Desc: ${customize.custom_description}`;
        }
        if (customize.custom_size && customize.custom_size.trim() !== "") {
          itemMessage += `\nCustom Size: ${customize.custom_size}`;
        }
      }

      return itemMessage;
    }).join('\n\n');

    const finalMessage = `Hello, I would like to order these products.\n\n${productsList}\n\n────────────────────\nThank you!`;

    const encodedMessage = encodeURIComponent(finalMessage);
    const whatsappUrl = `https://wa.me/917984785574?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  // const handlePlaceOrder = () => {
  //   if (!cartData?.AddToCartDetails?.[0]?.length) {
  //     toast.warn("Cart is empty!");
  //     return;
  //   }

  //   const customerName = user ? `${user.First_Name} ${user.Last_Name}` : 'Guest';
  //   const customerEmail = user?.Email || 'Not Provided';
  //   const customerID = user?.UserID || 'N/A';

  //   let emailBody = `Hello,%0D%0A%0D%0ANew Order Details:%0D%0A%0D%0A`;
  //   emailBody += `Customer Name: ${customerName}%0D%0A`;
  //   emailBody += `Customer Email: ${customerEmail}%0D%0A`;
  //   emailBody += `════════════════════════════════%0D%0A%0D%0A`;
  //   emailBody += `ORDER ITEMS:%0D%0A`;

  //   cartData.AddToCartDetails[0].forEach((item, index) => {
  //     const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);

  //     emailBody += `${index + 1}. Product: ${encodeURIComponent(item.Product_Name)}%0D%0A`;
  //     emailBody += `   Category: ${encodeURIComponent(item.Category || 'N/A')}%0D%0A`;
  //     emailBody += `   Subcategory: ${encodeURIComponent(item.SubCategory || 'N/A')}%0D%0A`;
  //     emailBody += `   Size: ${encodeURIComponent(item.Size || 'Standard')}%0D%0A`;
  //     emailBody += `   Quantity: ${item.Quantity}%0D%0A`;

  //     if (customize) {
  //       if (customize.custom_description && customize.custom_description.trim() !== "") {
  //         emailBody += `   Custom Description: ${encodeURIComponent(customize.custom_description)}%0D%0A`;
  //       }
  //       if (customize.custom_size && customize.custom_size.trim() !== "") {
  //         emailBody += `   Custom Size: ${encodeURIComponent(customize.custom_size)}%0D%0A`;
  //       }
  //     }

  //     emailBody += `%0D%0A──────────────────────────────%0D%0A%0D%0A`;
  //   });

  //   emailBody += `%0D%0AThank you for your order!%0D%0A%0D%0ABest regards,%0D%0AVV Design Studio`;

  //   const subject = encodeURIComponent(`New Order from ${customerName} - VV Design Studio`);
  //   const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=visputevibha.15@gmail.com&su=${subject}&body=${emailBody}`;

  //   window.open(gmailUrl, '_blank');

  //   toast.success("Gmail opened! Please review and send the email.");
  // };

  const totalCartItems = cartData?.AddToCartDetails?.[0]?.length || 0;


  return (
    <>
      <div className="middle-head-inner-child">
        <div className="user-dropdown-wrapper">
          <Link to={user ? '/myaccount' : '/login'} className='middle-icon' id="middleusericon">
            <CiUser />
          </Link>

          <Button
            type="primary"
            onClick={openCart}
            style={{
              position: 'relative',
              background: 'transparent',
              border: 'none',
              padding: '8px',
              boxShadow: 'none'
            }}
          >
            <IoCartOutline
              className='middle-icon'
              id='middle-icon'
              style={{
                fontSize: '24px',
                color: '#000000'
              }}
            />
            {totalCartItems > 0 && (
              <span style={{
                position: 'absolute',
                top: '-6px',
                right: '-6px',
                background: '#6B9AB8',
                color: '#fff',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '11px',
                fontWeight: '600',
                border: '2px solid white'
              }}>
                {totalCartItems}
              </span>
            )}
          </Button>

          <Drawer title="My Cart" onClose={closeCart} open={isCartOpen}>
            <div className="cart-container">
              <div className="cart-content">
                {!cartData?.AddToCartDetails || cartData.AddToCartDetails[0].length === 0 ? (
                  <p>Your cart is empty.</p>
                ) : (
                  cartData.AddToCartDetails[0].map((item, index) => {
                    const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);

                    return (
                      <div className="cart-item" key={index}>
                        <img
                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.Product_Img}`}
                          alt={item.Product_Name}
                          className="cart-img"
                          onClick={() => handleQuickView(item)}
                        />
                        <div className="cart-info">
                          <p className="cart-title" onClick={() => handleQuickView(item)}>
                            {item.Product_Name}
                          </p>

                          {customize && (customize.custom_description || customize.custom_size) && (
                            <div className="custom-info">
                              {customize.custom_description && (
                                <p>Customize Description: {customize.custom_description}</p>
                              )}
                              {customize.custom_size && (
                                <p>Customize Size: {customize.custom_size}</p>
                              )}
                            </div>
                          )}

                          <div className="cart-qty">
                            <button onClick={() => updateQuantity(item, parseInt(item.Quantity) - 1)}>-</button>
                            <span>{item.Quantity}</span>
                            <button onClick={() => updateQuantity(item, parseInt(item.Quantity) + 1)}>+</button>
                          </div>
                        </div>

                        <button
                          className="delete-btn"
                          onClick={() => deleteCartItem(item)}
                          aria-label="Remove item"
                        >
                          <RiDeleteBin6Line />
                        </button>
                      </div>
                    );
                  })
                )}
              </div>

              {/* ✅ Footer with Both Buttons - Same Design */}
              <div className="cart-footer">
                {/* <button className="checkout-btn" onClick={handleCartWhatsAppMessage}>CHECK OUT TO WHATSAPP </button*/}
                <button className="checkout-btn" onClick={handleCheckout}>
                  CHECK OUT
                </button>
                {/* <button className="checkout-btn" onClick={handlePlaceOrder} style={{ marginTop: '10px' }}>
                  PLACE ORDER
                </button> */}
              </div>
            </div>
          </Drawer>
        </div>
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        centered
        width={600}
      >
        {selectedProduct ? (
          <div className="modal-layout">
            <div className="modal-left">
              <div className="modal-image-box">
                <img
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}${selectedProduct.Product_Img}`}
                  alt={selectedProduct.Product_Name}
                />
              </div>
            </div>
            <div className="modal-right">
              <h2 className="product-name">{selectedProduct.Product_Name}</h2>
              <p>Category: {selectedProduct.Category}</p>
              <p>Subcategory: {selectedProduct.SubCategory}</p>

              <div className="cart-qty">
                <div className="qty-buttons">
                  <button onClick={() => setQuantity(prev => Math.max(1, prev - 1))}>-</button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity(prev => prev + 1)}>+</button>
                </div>
              </div>

              <button className="add-to-cart" onClick={() => updateQuantity(selectedProduct, quantity)}>
                Update Cart
              </button>
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </>
  );
};

export default Cart;